import React, { useEffect } from "react";
import { addFaq, getActiveFQACategory, updateFaq } from "../../../actions/utilitiesAction";
import Add from "../../../component/Utilities/FAQs/AddFAQ";
import constant from "../../../constant";
import { useState } from "react";

const AddFAQ = () => {

    const [response, setResponse] = useState({})
    const [showMsg, setShowMsg] = useState(false)
    const [list, setList] = useState([])

    const onSubmit = (model) => {
        if (model.type === 'ADD') {
            addFaq(model).then((res) => {
                setResponse(res)
                setShowMsg(true)
                setTimeout(() => {
                    setShowMsg(false)
                }, 7000)
                window.location.href = constant.component.faqlist.url;
                // if (res.status) {
                //     alert(res.messageCode)
                //     window.location.href = constant.component.faqlist.url;
                // }
            }).catch((err) => {
                alert(err)
            })
        } else {
            updateFaq(model).then((res) => {
                // if (res.status) {
                //     alert(res.messageCode)
                //     window.location.href = constant.component.faqlist.url;
                // }
                setResponse(res)
                setShowMsg(true)
                setTimeout(() => {
                    setShowMsg(false)
                }, 7000)
                window.location.href = constant.component.faqlist.url;
            }).catch((err) => {
                alert(err)
            })
        }

    }
    useEffect(() => {
        getActiveFQACategory().then((res) => {
            setList(res.result)
        }).catch((err) => {
            alert(err)
        })
    }, [])

    return (
        <React.Fragment>
            <Add list={list} onSubmit={(data) => onSubmit(data)} response={response} showMsg={showMsg} />
        </React.Fragment>
    )
}

export default AddFAQ;